import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormTable = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  span {
    color: #f30303;
    font-size: 14px;
    line-height: 14px;
    font-weight: 700;
    margin-right: 400px;
  }
`;

export const Table = styled.div`
  > P {
    margin: 35px 0px;
    color: var(--color-primary);
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
  }
`;

interface TheadTableProps {
  hasFaturas: boolean;
}

export const TheadTable = styled.thead<TheadTableProps>`
  color: ${(props) => (!props.hasFaturas ? '#ffffff' : '#707070')};
  width: ${(props) => !props.hasFaturas && '170px'};
  border-right: ${(props) => props.hasFaturas && '1px solid #707070'};
  font-weight: 700;

  &:last-child {
    border-right: 0;
  }

  tr {
    background: ${(props) =>
      !props.hasFaturas ? 'var(--color-primary)' : '#e9e9e9'};
    &:last-child {
      border-right: 0;
    }
  }
`;

export const FaturasTable = styled.table`
  border-collapse: collapse;
  margin-top: 25px;
  margin-bottom: 16px;
  width: 1080px;
  overflow: hidden;
  border-radius: 5px 5px 0 0;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  &:last-child {
    border-right: 0;
  }

  th {
    font-size: 11px;
    padding: 10px 2px;
    border-right: 1px solid #c4c4c4;

    &:last-child {
      border-right: 0;
    }
  }
  td {
    border-right: 1px solid #c4c4c4;
    &:last-child {
      border-right: 0;
    }
  }

  tbody tr {
    border-bottom: 2px solid #c4c4c4;
    td {
      width: 170px;

      text-align: center;
      input {
        width: 100%;
        height: 35px;
        border: 0;
        text-align: center;
        font-size: 12px;
        font-weight: 700;
        color: #707070;
        outline: 0;
      }
    }
    #open {
      width: 200px;
    }
  }
`;

interface FaturasProps {
  isSelected: boolean;
}

export const Faturas = styled.tr<FaturasProps>`
  background: ${(props) => props.isSelected && '#e9e9e9'};
`;

export const ButtonActions = styled.td`
  margin-top: 10px;
  margin-bottom: 10px;
  width: 90px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  img {
    cursor: pointer;
    height: 16px;
  }

  button {
    border: 0;
    background: transparent;
  }
`;

export const AddButton = styled.div`
  display: flex;
  align-items: flex-end;

  button {
    width: 150px;
    height: 30px;
    border: 1px solid #c4c4c4;
    border-radius: 5px;

    background: #fff;

    color: #707070;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;

    &:first-child {
      margin-right: 10px;
    }
  }
`;
